<template>
  <div
    class="activity-wrap"
    :style="{'opacity': statusName(activityInfo.status).opacity}"
    @mouseover="mouseOver(activityInfo.page)"
    @mouseleave="wxCodeShow = false"
  >
    <div class="pic-wrap">
      <div class="status" :style="{background: statusName(activityInfo.status).color, 'opacity': statusName(activityInfo.status).opacity}">{{ statusName(activityInfo.status).label }}</div>
      <el-image
        style="width: 287.5px; height: 157px"
        :src="activityInfo.coverPicture"
        fit="cover"></el-image>
      <transition name="el-fade-in-linear">
        <div class="wx-zhezhao" v-show="wxCodeShow">
          <div class="wx-img">
            <el-image
              style="width: 90px; height: 90px"
              :src="wxCode"
              fit="cover">
              <div slot="error" class="image-slot wx-code-loading" style="padding-top: 20px;">
                <i class="el-icon-loading" style="font-size: 30px;"></i>
                <div class="text" style="font-size: 12px;">加载中</div>
              </div>
            </el-image>
          </div>
          <div class="wx-text">扫码查看活动详情</div>
        </div>
      </transition>
    </div>
    <div class="info">
      <p>{{ activityInfo.name }}</p>
      <div class="time">
        <span>{{ activityTime() }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'hot-activity',
  props: {
    activityInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      wxCode: null,
      wxCodeShow: false,
      timer: null,
      status: [
        { label: '未开始', value: 0, color: '#000000', opacity: 1 },
        { label: '进行中', value: 1, color: 'linear-gradient(42deg, #EBD39F 0%, #BDA26C 100%)', opacity: 1 },
        { label: '已结束', value: 2, color: '#000000', opacity: 0.5 },
      ]
    }
  },
  methods: {
    activityTime () {
      const { exhibitionActivityType: type, enrollIsOpen } = this.activityInfo
      if (type === 'vote') return `${enrollIsOpen === 1 ? '参赛' : '投票'}时间：${this.translateStamp()}`
      if (['activitySquare', 'common'].includes(type)) return `活动时间：${this.translateDate()}`
      return `活动时间：${this.translateTime()}`
    },
    translateDate () {
      const { activityStartDate, activityEndDate } = this.activityInfo
      return `${this.$day(activityStartDate).format('YYYY/MM/DD')} - ${this.$day(activityEndDate).format('YYYY/MM/DD')}`
    },
    translateStamp () {
      const { enrollIsOpen, enrollStartTime, enrollEndTime, voteStartTime, voteEndTime } = this.activityInfo
      const endTime = this.$day(enrollIsOpen === 1 ? enrollEndTime : voteEndTime).format('YYYY/MM/DD')
      return `${this.$day(enrollIsOpen === 1 ? enrollStartTime : voteStartTime).format('YYYY/MM/DD')} - ${endTime}`
    },
    translateTime () {
      const { activityStartTime, activityEndTime } = this.activityInfo
      return `${this.$day(activityStartTime).format('YYYY/MM/DD')} - ${this.$day(activityEndTime).format('YYYY/MM/DD')}`
    },
    statusName (value) {
      const item = this.status.find(child => child.value === value) || {}
      return item
    },
    mouseOver(url){
      this.wxCodeShow = true
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.wxCode) {
          return
        }
        this.getWxaCode(url)
      }, 500);
    },
    // 生成小程序二维码
    getWxaCode(url){
      this.$api.getWxaCode(url).then(res => {
        const wxCode = res.data
        this.wxCode = wxCode
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.activity-wrap{
  cursor: pointer;
  box-sizing: border-box;
  width: 287.5px;
  .pic-wrap{
    width: 287.5px;
    height: 157px;
    position: relative;
    .status{
      position: absolute;
      left: 0;
      top: 0;
      width: 86px;
      height: 30px;
      @include font18(400, #fff);
      text-align: center;
      line-height: 30px;
      border-radius: 2px 0px 12px 0px;
      z-index: 100;
      background-color: red
    }
    .wx-zhezhao{
      width: 287.5px;
      height: 157px;
      position: absolute;
      left: 0;
      top: 0;
      background: rgba($color: #000000, $alpha: 0.4);
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      z-index: 100;
      .wx-img{
        margin-top: 29px;
        width: 90px;
        height: 90px;
        background: #fff;
      }
      .wx-text{
        width: 480px;
        @include font12(400, #fff);
        text-align: center;
        padding-bottom: 10px;
      }
    }
  }
  .info{
    p {
      @include font18(500, #3E3E3E);
      margin-top: 12px;
    }
    .time{
      @include font14(400, #9399A5);
      margin-top: 8px;
    }
  }
}
</style>
